const CLIENT_MANIFEST_HREF = '/client-manifest.webmanifest';
const ADMIN_MANIFEST_HREF = '/manifest.webmanifest';
const CLIENT_APP_TITLE = 'Twin Turbo Client';
const ADMIN_APP_TITLE = 'TT Admin';

/* Single SPA, single index.html, but two installable identities: the dispatcher admin and the
   provider "client cabinet" (role PROVIDER, routed under /client — see router.tsx) shouldn't
   install to the home screen under the same name/icon set. Browsers re-read <link rel=manifest>
   at install-prompt time, so swapping its href (and the iOS-only apple-mobile-web-app-title meta,
   which manifest.json can't reach — iOS "Add to Home Screen" ignores the manifest entirely) is
   enough; no second index.html or build target needed.

   Pathname-based, not auth-store-based: /client is only ever reachable as the PROVIDER role
   (router.tsx redirects any other role away from it), so the path alone is a reliable signal and
   doesn't race the auth store's own hydration. */
export function applyManifestForPath(pathname: string): void {
  const isClient = pathname.startsWith('/client');

  const manifestLink = document.head.querySelector<HTMLLinkElement>('link[rel="manifest"]');
  if (manifestLink) {
    manifestLink.href = isClient ? CLIENT_MANIFEST_HREF : ADMIN_MANIFEST_HREF;
  }

  const titleMeta = document.head.querySelector<HTMLMetaElement>(
    'meta[name="apple-mobile-web-app-title"]',
  );
  if (titleMeta) {
    titleMeta.content = isClient ? CLIENT_APP_TITLE : ADMIN_APP_TITLE;
  }
}
